import React from 'react';
import { CardSubtitle } from 'reactstrap';
import { UncontrolledTable } from '~/components';
import usePatient from '~/utils/patient/hook';
import { TableFilterDateRange, TableFilterIdentitySource } from '~/components/Filters';
import { MatchStatus } from '~/utils/const/identity';

const MedicationsAndPharmacies = () => {
  const [
    ,
    { sacwisPersonId: sacwisId },
  ] = usePatient();

  return (
    <React.Fragment>
      <CardSubtitle tag="h5" className="m-3">
        Medications
      </CardSubtitle>

      <UncontrolledTable
        name="medications"
        className="mx-4"
        endpoint={{
          url: 'data/public/list-view-cs-tbl-medication',
          params: {
            sacwis_id: sacwisId,
            match_status_id: MatchStatus.Approved,
          },
        }}
        defaultSorted={[{ id: 'medication' }]}
        columns={[
          {
            id: 'medication',
            Header: 'Medication',
            accessor: 'attributes.medication',
          },
          {
            id: 'dosage',
            Header: 'Dosage',
            accessor: 'attributes.dose',
          },
          {
            id: 'instructions',
            Header: 'Instructions',
            accessor: 'attributes.instructions',
          },
          {
            id: 'startdateDt__>>',
            Header: 'Start Date',
            accessor: 'attributes.startdateDt',
            cellType: 'date',
            Filter: d => <TableFilterDateRange {...d} />,
          },
          {
            id: 'enddateDt__>>',
            Header: 'End Date',
            accessor: 'attributes.enddateDt',
            cellType: 'date',
            Filter: d => <TableFilterDateRange {...d} />,
          },
          {
            id: 'refills',
            Header: 'Refills',
            accessor: 'attributes.refills',
          },
          {
            id: 'sourceDescription',
            Header: 'Reporting Healthcare Institution',
            accessor: 'attributes.sourceDescription',
            Filter: d => <TableFilterIdentitySource {...d} />,
          },
          {
            id: 'medlastrevtmTs__>>',
            Header: 'Last Reviewed Date',
            accessor: 'attributes.medlastrevtmTs',
            cellType: 'date',
            Filter: d => <TableFilterDateRange {...d} />,
          },
        ]}
      />

      <CardSubtitle tag="h5" className="m-3">
        Most Recent Pharmacy
      </CardSubtitle>

      <UncontrolledTable
        name="most-recent-pharmacy"
        className="mx-4"
        endpoint={{
          url: 'data/public/list-view-cs-tbl-pharmacy',
          params: {
            sacwis_id: sacwisId,
            match_status_id: MatchStatus.Approved,
            pharmtype: 'Most Recent',
          },
        }}
        defaultSorted={[{ id: 'dateidentifiedTs', desc: true }]}
        columns={[
          {
            id: 'name',
            Header: 'Name',
            accessor: 'attributes.name',
          },
          {
            id: 'phone',
            Header: 'Phone',
            accessor: 'attributes.phone',
            cellType: 'tel',
          },
          {
            id: 'address',
            Header: 'Address',
            filterable: false,
            accessor: 'attributes',
            Cell: d => (
              <div className="text-white-space-normal">
                {d.original.attributes.address} {d.original.attributes.city},{' '}
                {d.original.attributes.state} {d.original.attributes.zip}
              </div>
            ),
          },
          {
            id: 'dateidentifiedTs',
            Header: 'Date Identified',
            accessor: 'attributes.dateidentifiedTs',
            cellType: 'date',
          },
          {
            id: 'sourceDescription',
            Header: 'Reporting Healthcare Institution',
            accessor: 'attributes.sourceDescription',
            Filter: d => <TableFilterIdentitySource {...d} />,
          },
        ]}
      />
    </React.Fragment>
  );
};

export default MedicationsAndPharmacies;
